<template>
    <div class="auth-container">
        <img class="logo" :src="Logo" alt="Logo">

        <router-view
            @alertMsg="alertMsg"
        >
        </router-view>
        <template v-if="alertMsgs">
            <Alert
                :type="alertMsgs.type"
                :key="alertMsgs.key"
                class="alert"
            >
                {{ alertMsgs.message }}
            </Alert>
        </template>


        <!-- 
        <router-link  
            v-if="route == 'Login'"
            tag="span" 
            style="color: #fff; width: 100%; display: inline-block; position: absolute; bottom: 30px; left: 0; text-align: center;" 
            :to="{ name: 'PreRegister' }">
            عضو شوید
        </router-link> 
        -->
        <!-- 
        <router-link  
            v-if="route == 'PreRegister'"
            tag="span" 
            style="color: #fff; width: 100%; display: inline-block; position: absolute; bottom: 30px; left: 0; text-align: center;" 
            :to="{ name: 'Login' }">
            وارد شوید
        </router-link> 
        -->
        <router-link
            tag="span" 
            style="color: #fff; display: inline-block; position: absolute; top: 10px; left: 10px;" 
            :to="{ name: 'Khanesh' }"
        ><i class="far fa-home"></i></router-link>

        <img class="corner" :src="Corner" alt="Corner">
    </div>
</template>

<script>
import Alert from '@/components/Alert';

import Logo from '@/assets/images/auth-logo.png';
import Corner from '@/assets/images/auth-corner.png';

export default {
    name: 'auth',
    components: {
        Alert
    },
    data() {
        return {
            route: this.$route.name,
            Logo: Logo,
            Corner: Corner,

            alertMsgs: undefined
        }
    },
    watch: {
        '$route'() {
            this.route = this.$route.name;
            this.alertMsgs = undefined;
        }
    },
    methods: {
        alertMsg(msg) {
            this.alertMsgs = msg;
        }
    }
}
</script>

<style scoped>
.auth-container {
    height: 100vh;
    width: 100%;

    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;

    background-color: #232f7e;
}
.auth-container .logo {
    width: 30vw;
    margin: auto auto 0;
    padding-top: 10px;
}
.auth-container .corner {
    height: 70vw;
    margin: auto auto -20vw -20vw;
}
</style>